export var name = 'outrights';
export var OUTRIGHTS_SOCKET_NAME = 'outrights';
